<template>
  <nav class="bg-primary-dark">
    <NavbarDesktop v-if="context" :visible="visible" @toggle="toggle" />
    <NavbarMobile v-if="context" :visible="visible" />
    <NavbarDefault v-if="!context" />
  </nav>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const visible = ref(false);
const context = computed(() => store.getters['context/context']);
const toggle = () => visible.value = ! visible.value;
</script>

